var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hamburger menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "navigationretailmobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-23.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hamburger-menu",
    transform: "translate(23.000000, 19.000000)",
    fill: "#1A1919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52751724,-8.54180296 C8.98274581,-8.54180296 8.54180296,-8.10152709 8.54180296,-7.55904433 L8.54180296,9.53047291 C8.54180296,10.0729557 8.98274581,10.5132315 9.52751724,10.5132315 C10.0716315,10.5132315 10.5132315,10.0729557 10.5132315,9.53047291 L10.5132315,-7.55904433 C10.5132315,-8.10152709 10.0716315,-8.54180296 9.52751724,-8.54180296",
    id: "Fill-21-Copy-2",
    transform: "translate(9.527517, 0.985714) scale(-1, 1) rotate(90.000000) translate(-9.527517, -0.985714) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52751724,-2.54180296 C8.98274581,-2.54180296 8.54180296,-2.10152709 8.54180296,-1.55904433 L8.54180296,15.5304729 C8.54180296,16.0729557 8.98274581,16.5132315 9.52751724,16.5132315 C10.0716315,16.5132315 10.5132315,16.0729557 10.5132315,15.5304729 L10.5132315,-1.55904433 C10.5132315,-2.10152709 10.0716315,-2.54180296 9.52751724,-2.54180296",
    id: "Fill-21-Copy-3",
    transform: "translate(9.527517, 6.985714) scale(-1, 1) rotate(90.000000) translate(-9.527517, -6.985714) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52751724,3.45819704 C8.98274581,3.45819704 8.54180296,3.89847291 8.54180296,4.44095567 L8.54180296,21.5304729 C8.54180296,22.0729557 8.98274581,22.5132315 9.52751724,22.5132315 C10.0716315,22.5132315 10.5132315,22.0729557 10.5132315,21.5304729 L10.5132315,4.44095567 C10.5132315,3.89847291 10.0716315,3.45819704 9.52751724,3.45819704",
    id: "Fill-21-Copy-4",
    transform: "translate(9.527517, 12.985714) scale(-1, 1) rotate(90.000000) translate(-9.527517, -12.985714) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.a8ff390c.svg";
export { ForwardRef as ReactComponent };